var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-check-e"},[_c('weekLIst',{staticClass:"weekLIst"}),_c('echartDemo',{attrs:{"option":_vm.option,"id":"first-check-e"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }